import type { BlockUIDesignTokens, BlockUITokenSections } from '@openng/optimus-ui-themes/types/blockui';

export const root: BlockUITokenSections.Root = {
    borderRadius: '{content.border.radius}'
};

export default {
    root
} satisfies BlockUIDesignTokens;
